import examples from '../data/examples.json.js';

// Importing from `.json.js` a workaround for a bug in web browsers' "native"
// import phoneFormats from '../data/formats.json';

/** ---------------------------------------------------------------------------------------
 * getExample
 * 
 * @param {string} country - The two letter country string
 * @param {string} type - The type of example. e.g ["fixed", "mobile", "tollfree"]
 *
 * @return {string} An example number
 */
const getExample = (country, type) => {
  const exmpls = examples[country];
  if( !exmpls ){
    console.warn(`intl-phone does not currently support country ${country}`);
    return;
  }
  return exmpls[type];
};

export { getExample };
